import { isTelegramEnv } from '@/telegram';
import type { AuthRuntime } from './store';

export function detectAuthRuntime(): AuthRuntime {
  return isTelegramEnv() ? 'telegram' : 'web';
}
